import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useQualityIndicatorFlag(): CachedFlag<'qualityIndicator'> {
  return useCachedFlag('qualityIndicator')
}
